import { buildModelManager } from "../builder.js";
const DefaultWhatsappFlowScreensSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  customField: true,
  customerId: true,
  fieldType: true,
  label: true,
  screenField: true,
  screenPosition: true,
  screenTitle: true,
  updatedAt: true,
  whatsappFlowId: true
};
const modelApiIdentifier = "whatsappFlowScreens";
const pluralModelApiIdentifier = "whatsappFlowScreenss";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappFlowScreensSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappFlowScreensSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappFlowScreensSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappFlowScreensSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappFlowScreensSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappFlowScreensSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappFlowScreensSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createWhatsappFlowScreens",
    operationReturnType: "CreateWhatsappFlowScreens",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      whatsappFlowScreens: { required: false, type: "CreateWhatsappFlowScreensInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappFlowScreensSelection
  },
  {
    type: "action",
    operationName: "bulkCreateWhatsappFlowScreens",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateWhatsappFlowScreensInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappFlowScreensSelection
  },
  {
    type: "action",
    operationName: "updateWhatsappFlowScreens",
    operationReturnType: "UpdateWhatsappFlowScreens",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      whatsappFlowScreens: { required: false, type: "UpdateWhatsappFlowScreensInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappFlowScreensSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateWhatsappFlowScreens",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateWhatsappFlowScreensInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappFlowScreensSelection
  },
  {
    type: "action",
    operationName: "deleteWhatsappFlowScreens",
    operationReturnType: "DeleteWhatsappFlowScreens",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteWhatsappFlowScreens",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertWhatsappFlowScreens",
    operationReturnType: "UpsertWhatsappFlowScreens",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      whatsappFlowScreens: { required: false, type: "UpsertWhatsappFlowScreensInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateWhatsappFlowScreensResult": { hasReturnType: false },
      "... on UpdateWhatsappFlowScreensResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappFlowScreensSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertWhatsappFlowScreens",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertWhatsappFlowScreensInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultWhatsappFlowScreensSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "whatsappFlowScreensGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const WhatsappFlowScreensManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultWhatsappFlowScreensSelection,
  operations
);
export {
  DefaultWhatsappFlowScreensSelection,
  WhatsappFlowScreensManager
};
//# sourceMappingURL=WhatsappFlowScreens.js.map
